var _rect, _rect2, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlanStandardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 57,
    viewBox: "0 0 56 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.500244,
    y: 1.36755,
    width: 55,
    height: 55,
    rx: 3.5,
    fill: "url(#paint0_linear_66_10612)",
    stroke: "#D2D2D2"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_66_10612",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 57,
    height: 57
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.000244141,
    y: 0.867554,
    width: 56,
    height: 56,
    rx: 2,
    fill: "#C4C4C4"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_66_10612)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.2534 13.9257C74.2534 3.30077 74.2534 -2.0117 70.9537 -5.31368C67.6495 -8.6134 62.3392 -8.6134 51.7143 -8.6134C41.0894 -8.6134 35.7769 -8.6134 32.4772 -5.31368C29.1752 -2.00945 29.1752 3.30077 29.1752 13.9257C29.1752 24.5506 29.1752 29.8631 32.4772 33.1628C35.7747 36.4648 41.0894 36.4648 51.7143 36.4648C62.3392 36.4648 67.6517 36.4648 70.9537 33.1628C74.2534 29.8654 74.2534 24.5506 74.2534 13.9257Z",
    stroke: "#3632D5",
    style: {
      mixBlendMode: "hard-light"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6687 28.8675C11.6687 21.1689 11.6687 17.3195 14.0596 14.9269C16.4538 12.536 20.3016 12.536 28.0002 12.536C35.6989 12.536 39.5483 12.536 41.9392 14.9269C44.3318 17.3212 44.3318 21.1689 44.3318 28.8675C44.3318 36.5662 44.3318 40.4156 41.9392 42.8065C39.5499 45.1991 35.6989 45.1991 28.0002 45.1991C20.3016 45.1991 16.4522 45.1991 14.0596 42.8065C11.6687 40.4172 11.6687 36.5662 11.6687 28.8675Z",
    fill: "url(#paint1_linear_66_10612)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_66_10612",
    x1: 28.0002,
    y1: 0.867554,
    x2: 28.0002,
    y2: 56.8676,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.635361,
    stopColor: "#F7FAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C2DAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_66_10612",
    x1: 41.879,
    y1: 12.536,
    x2: 15.8513,
    y2: 45.1992,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A6FF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9FD8F8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanStandardIcon);
export default __webpack_public_path__ + "static/media/PlanStandardIcon.5d1808e43d7bebeb5b8ee5c7fee13eb0.svg";
export { ForwardRef as ReactComponent };